import { SideNavLayout } from "common/layouts/SideNavLayout";
import { UserChallenges } from "features/homepage/Challenges";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { routes as adminRoutes } from "../admin/AdminApp";
import { ChallengeMap } from "../ChallengeMap";
import { ChallengeShowPage } from "../ChallengeShowPage";

export const routes = [
  <Route key="challenges" path="/challenges" exact component={UserChallenges} />,
  <Route key="challengesId" path="/challenges/:challengeId">
    <Switch>
      <Route path="/challenges/:challengeId" exact>
        <SideNavLayout greyBg>
          <ChallengeShowPage />
        </SideNavLayout>
      </Route>
      <Route path="/challenges/:challengeId/route_map" component={ChallengeMap} />
      {adminRoutes}
    </Switch>
  </Route>,
];
